/**
 * An operator that compares two values.
 * 
 * @enum {number}
 */
export const ConditionOperator = {
    /**
     * The first operand contains the second operand.
     */
    Contains: 1,

    /**
     * The first operand ends with the second operand.
     */
    EndsWith: 2,

    /**
     * The operands are the same value.
     */
    Equal: 3,

    /**
     * The first operand is greater than the second.
     */
    GreaterThan: 4,

    /**
     * The first operand is greater than or equal to the second.
     */
    GreaterThanOrEqual: 5,

    /**
     * The first operand is less than the second.
     */
    LessThan: 6,

    /**
     * The first operand is less than or equal to the second.
     */
    LessThanOrEqual: 7,

    /**
     * The first operand does not contain the second operand.
     */
    NotContains: 8,

    /**
     * The operands are not the same value.
     */
    NotEqual: 9,

    /**
     * The first operand starts with the second operand.
     */
    StartsWith: 10
};
